// Copyright (C) AirWorks Solutions, Inc - All Rights Reserved
// DO NOT REDISTRIBUTE
// UNAUTHORIZED COPYING OF THIS FILE, ANY PART OR WHOLE, VIA ANY MEDIUM IS STRICTLY PROHIBITED
// PROPRIETARY AND CONFIDENTIAL

import { awSignUpPalette } from 'Utils/themes';

// Size of the circular mail badge in the Figma "Check your email" board
const BADGE_SIZE_PX = 72;

const styles = (theme: any) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    gap: theme.spacing(2.5),
    paddingTop: theme.spacing(4),
  },
  badge: {
    width: `${BADGE_SIZE_PX}px`,
    height: `${BADGE_SIZE_PX}px`,
    borderRadius: '50%',
    background: awSignUpPalette.badgeBackground,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  badgeIcon: {
    fontSize: theme.spacing(4),
    color: '#FFFFFF',
  },
  header: {
    color: '#FFFFFF',
  },
  details: {
    color: awSignUpPalette.bodyText,
  },
  emailChip: {
    background: awSignUpPalette.cardBackground,
    border: `1px solid ${awSignUpPalette.cardBorder}`,
    borderRadius: theme.spacing(1),
    padding: theme.spacing(1.5, 2.5),
    color: '#FFFFFF',
    fontWeight: 600,
    wordBreak: 'break-all',
  },
  helpText: {
    color: awSignUpPalette.mutedText,
    maxWidth: '300px',
  },
  link: {
    color: awSignUpPalette.link,
    fontWeight: 600,
  },
});

export default styles;
